module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"company_profiles":{"index":{"asset_managers":"Fondsgesellschaften","financial_service_providers":"Finanzdienstleister","meta_tags":{"description":"Alles Wichtige auf einen Blick: Unternehmensportrait, Ansprechpartner, Fonds und aktuelle Beiträge."},"subtitle":"Ausgewählte Unternehmen von A bis Z","title":"Firmenprofile","wealth_managers":"Vermögensverwalter"}}}}}}')
  delete Component.options._Ctor
}
